import { gql } from '@apollo/client'

export const createContribution = gql`
  mutation createContribution($data: CreateContributionInput!) {
    contribute(data: $data) {
      id
      amount
      fee
      netAmount
      state
      referrerUrl
      utmSource
      utmMedium
      utmCampaign
      utmTerm
      utmContent
    }
  }
`

export const chargeContribution = gql`
  mutation chargeContribution($contributionId: Int!, $processor: String) {
    chargeContribution(contributionId: $contributionId, processor: $processor) {
      id
      amount
      fee
      netAmount
      state
    }
  }
`

export const cancelContribution = gql`
  mutation cancelContribution($id: Int!, $fundId: Int!) {
    cancelContribution(id: $id, fundId: $fundId) {
      id
      amount
    }
  }
`

export const cancelRecurringContribution = gql`
  mutation cancelRecurrentContribution($id: Int!, $fundId: Int!) {
    cancelRecurrentContribution(id: $id, fundId: $fundId) {
      id
      amount
      frequency
      nextScheduledCharge
      state
      dayInMonth
      monthInYear
    }
  }
`

export const changeContributionState = gql`
  mutation changeContributionState($ids: [Int!]!, $state: String!) {
    changeContributionState(ids: $ids, state: $state)
  }
`

export const updateRecurrentContributionPaymentMethod = gql`
  mutation updateRecurrentContributionPaymentMethod($id: Int!, $fundId: Int!, $paymentMethodId: Int!) {
    updateRecurrentContributionPaymentMethod(id: $id, fundId: $fundId, paymentMethodId: $paymentMethodId) {
      id
    }
  }
`

export const userUpdateRecurrentContribution = gql`
  mutation userUpdateRecurrentContribution($data: UpdateRecurrentContributionInput!) {
    userUpdateRecurrentContribution(data: $data) {
      id
    }
  }
`

export const createContributionRecord = gql`
  mutation createContributionRecord(
    $fundId: Int!
    $amount: Float!
    $paymentType: Int!
    $description: String!
    $taxReceipted: Boolean!
    $state: Int
    $charityId: String
    $usedGiveGenius: Boolean
    $isRecurring: Boolean
    $recurringInterval: String
    $processingDate: String
    $paymentIntentId: String
    $referrerUrl: String
    $utmSource: String
    $utmMedium: String
    $utmCampaign: String
    $utmTerm: String
    $utmContent: String
    $deliveringCustodianInfo: DeliveringCustodianInfoInput
    $securitiesDescription: String
    $securitiesSymbol: String
    $securitiesQuantity: String
  ) {
    createContributionRecord(
      fundId: $fundId
      amount: $amount
      paymentType: $paymentType
      description: $description
      taxReceipted: $taxReceipted
      state: $state
      charityId: $charityId
      usedGiveGenius: $usedGiveGenius
      isRecurring: $isRecurring
      recurringInterval: $recurringInterval
      processingDate: $processingDate
      paymentIntentId: $paymentIntentId
      referrerUrl: $referrerUrl
      utmSource: $utmSource
      utmMedium: $utmMedium
      utmCampaign: $utmCampaign
      utmTerm: $utmTerm
      utmContent: $utmContent
      deliveringCustodianInfo: $deliveringCustodianInfo
      securitiesDescription: $securitiesDescription
      securitiesSymbol: $securitiesSymbol
      securitiesQuantity: $securitiesQuantity
    ) {
      id
      amount
      fee
      netAmount
      state
      referrerUrl
      utmSource
      utmMedium
      utmCampaign
      utmTerm
      utmContent
    }
  }
`

export const generateLetterofDirection = gql`
  mutation generateLetterofDirection($data: CreateSecuritiesInput!) {
    generateLetterofDirection(data: $data)
  }
`

export const completeRequestedSecuritiesContribution = gql`
  mutation completeRequestedSecuritiesContribution(
    $contributionId: Int!
    $fundId: Int!
    $deliveringCustodianInfo: DeliveringCustodianInfoInput!
    $securities: [SecurityInput!]!
  ) {
    completeRequestedSecuritiesContribution(
      contributionId: $contributionId
      fundId: $fundId
      deliveringCustodianInfo: $deliveringCustodianInfo
      securities: $securities
    ) {
      id
      amount
      state
    }
  }
`
